import 'antd/dist/reset.css';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import './app/i18n';
import { ErrorBoundary } from './app/ErrorBoundary';
import { Providers } from './app/providers';
import { App } from './app/App';
import { ensureCodeFont } from './app/codeFont';
ensureCodeFont();
const container = document.getElementById('root');
if (container === null) throw new Error('index.html 里找不到 #root');
createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <BrowserRouter>
        <Providers>
          <App />
        </Providers>
      </BrowserRouter>
    </ErrorBoundary>
  </StrictMode>,
);
